export default {
  女装: "Women's Apparel",
  男装: "Men's Wear",
  手机和小工具: "Mobile & Gadgets",
  居家生活: "Home & Living",
  电脑及周边设备: "Computers & Peripherals",
  美容及个人护理: "Beauty & Personal Care",
  家用电器: "Home Appliances",
  健康与保健: "Health & Wellness",
  食品和饮料: "Food & Beverages",
  玩具_儿童和婴儿: "Toys, Kids & Babies",
  童装时尚: "Kids Fashion",
  视频游戏: "Video Games",
  运动与户外: "Sports & Outdoors",
  爱好与书籍: "Hobbies & Books",
  相机和无人机: "Cameras & Drones",
  宠物食品及用品: "Pet Food & Supplies",
  女士包袋: "Women's Bags",
  男士包袋: "Men's Bags",
  珠宝及配饰: "Jewellery & Accessories",
  手表: "Watches",
  女鞋: "Women's Shoes",
  男装鞋: "Men's Shoes",
  汽车: "Automotive",
  我附近的ShopeePay: "ShopeePay Near Me",
  餐饮_旅行和服务: "Dining, Travel & Services",
  旅行及行李: "Travel & Luggage",
  各种各样的: "Miscellaneous",
  我是来买什么的: "What am I here to buy?",
  对不起_找不到_相关的商品: "Sorry, no products related to [{0}] were found",
  类别: "Category",
  产品: "Product",
  店铺: "Shop",
  首页: "Front page",
  限时秒杀: "Limited time flash sale",
  博客: "Blog",
  所有品牌: "All brands",
  所有类别: "All categories",
  我的购物车: "My shopping cart",
  发货信息: "Delivery information",
  交货信息: "Delivery information",
  付款: "Payment",
  确认: "Confirm",
  您的购物车是空的: "Your shopping cart is empty",
  价格: "Price",
  税: "Tax",
  数量: "Quantity",
  总计: "Total",
  移除: "Remove",
  返回商店: "Return to store",
  继续发货: "Continue to ship",
  筛选: "Filter",
  价格范围: "Price range",
  排序方式: "Sort by",
  最新: "Up to date",
  最旧: "Oldest",
  价格从低到高: "Price from low to high",
  价格从高到低: "Price from high to low",
  选择交货类型: "Select delivery type",
  送货上门: "Delivery",
  继续付款: "Continue to pay",
  任何其他信息: "Any other information",
  或者: "Or",
  您的钱包余额: "Your wallet balance",
  余额不足: "Insufficient balance",
  支付: "Pay",
  我同意: "I agree",
  条款和条件: "Terms and Conditions",
  退货政策: "Return policy",
  隐私政策: "Privacy Policy",
  概括: "Generalize",
  项目: "Project",
  全部的: "All",
  小计: "Subtotal",
  总运费: "Total shipping cost",
  有优惠码吗_在这里输入: "Is there a discount code? enter here",
  申请: "Apply",
  编辑: "Edit",
  删除: "Delete",
  添加新地址: "Add new address",
  继续交货信息: "Continue delivery information",
  选择一个地址: "Choose an address",
  购买历史: "Purchase history",
  下载: "Download",
  已发送退款请求: "Refund request sent",
  对比: "Compared",
  对话: "Dialogue",
  我的钱包: "My purse",
  工单: "Work order",
  管理个人资料: "Manage profile",
  登出: "Sign out",
  重置对比列表: "Reset comparison list",
  您的对比列表为空: "Your comparison list is empty",
  在您的购物车中: "In your shopping cart",
  在您的愿望清单中: "In your wish list",
  在您的预定列表中: "On your booking list",
  下载您的产品: "Download your product",
  选项: "Options",
  什么都没找到: "Nothing found",
  特色产品: "Featured products",
  最畅销: "Best seller",
  前_名: "Top {0}",
  查看更多: "See more",
  查看所有类别: "View all categories",
  十大品牌: "Top ten brands",
  查看所有品牌: "View all brands",
  登录: "Login",
  手机号码: "Phone number",
  密码: "Password",
  密码长度为6到16个字符: "Password length is 6 to 16 characters",
  验证码: "Verification code",
  登录中: "Login",
  游客登录: "Visitor login",
  注册您的商店: "Register your store",
  现在申请: "Apply now",
  成为商家: "Become a merchant",
  现在注册: "Register now",
  登录成功: "Landed successfully",
  通知: "Notify",
  未找到通知: "Notification not found",
  评论: "Comment",
  估计运输时间: "Estimated shipping time",
  天: "days",
  所售: "Sold",
  给商家留言: "Leave a message to the merchant",
  规格: "Specification",
  库存: "In stock",
  总价: "Total price",
  添加到购物车: "Add to Cart",
  立即购买: "Buy it now",
  缺货: "Out of stock",
  添加到愿望清单: "Add to wishlist",
  加入对比列表: "Add to comparison list",
  退款: "Refund",
  查看条款: "View terms",
  分享: "Share",
  描述: "Describe",
  相关产品: "Related Products",
  没有人问过商家: "No one asked the merchants",
  该产品暂无评论: "There are no reviews for this product yet",
  客户评论: "Customer reviews",
  访问商店: "Visit store",
  畅销产品: "Bestsellers",
  日期: "Date",
  订单编号: "Order number",
  总额: "Lump sum",
  状态: "State",
  愿望清单: "Wishlist",
  还没有添加任何东西: "Nothing has been added yet",
  注册: "Register",
  邀请码: "Invitation code",
  请输入邀请码: "Please enter the invitation code",
  用户名: "Username",
  请输入用户名: "Please enter user name",
  用户名长度为6_14个字符: "Username length is 6-14 characters",
  昵称: "Nick name",
  请输入手机号码: "Please enter the phone number",
  手机号码格式错误: "Wrong format of phone number",
  密码长度为6_16个字符: "Password length is 6-16 characters",
  确认密码: "Confirm Password",
  请输入确认密码: "Please enter the confirmation password",
  提款密码: "Withdrawal password",
  请输入提款密码: "Please enter the withdrawal password",
  提款密码长度为4_16个字符: "Withdrawal password length is 4-16 characters",
  请输入验证码: "Please enter verification code",
  在_s后发送: "Sent after {0}s",
  发送验证码: "Send the verification code",
  注册即表示您同意我们的条款和条件:
    "By signing up you agree to our terms and conditions.",
  创建账号: "Create an account",
  验证码发送成功: "Verification code sent successfully",
  确认密码不一致: "Confirm that the password is inconsistent",
  提款密码必须为数字: "Withdrawal password must be numeric",
  注册成功: "Registration success",
  购物车: "Shopping cart",
  账户: "Account",
  我的账户: "My account",
  已经有一个账户: "Already have an account",
  新地址: "New address",
  编辑地址: "Edit address",
  保存: "Save",
  是否默认: "Is it the default",
  具体地址: "Specific address",
  请输入具体地址: "Please enter specific address",
  地区: "Area",
  请输入地区: "Please enter region",
  城市: "City",
  请输入城市: "Please enter city",
  省份: "Province",
  请输入省份: "Please enter province",
  邮政编码: "Postal code",
  请输入邮政编码: "Please enter postal code",
  电话号码: "Telephone number",
  请输入电话号码: "Please enter your phone number",
  收货人: "Receiver",
  请输入收货人: "Please enter the consignee",
  保存成功: "Saved successfully",
  最畅销的商家: "Best Selling Merchants",
  查看所有的商家: "View all businesses",
  支持政策: "Support policy",
  您的电子邮件地址: "Your email address",
  订阅: "Subscription",
  联系方式: "Contact information",
  地址: "Address",
  美国伊利诺伊州霍夫曼庄园: "Hoffman Estates, Illinois, USA",
  快速链接: "Quick Links",
  商家政策: "Merchant policies",
  submit: "Submit",
  提款银行卡: "Withdrawal bank card",
  我的面板: "My panel",
  提示: "Hint",
  确定登出吗: "Are you sure you want to log out?",
  确定: "Sure",
  取消: "Cancel",
  项目添加到您的购物车: "Add item to your shopping cart",
  经常一起购买: "Often buy together",
  返回购物: "Return to shopping",
  进行结算: "Proceed to checkout",
  帮助热线: "Helpline",
  查看所有通知: "View all notifications",
  请输入密码: "Please enter password",
  前往充值: "Go to recharge",
  购物车物品: "Shopping cart items",
  查看购物车: "Check the shopping cart",
  钱包余额: "Wallet balance",
  充值钱包: "Recharge wallet",
  钱包充值_线下_: "Wallet recharge (offline)",
  申请提款: "Apply for withdrawal",
  钱包收支明细: "Wallet Income and Expenditure Details",
  批准: "Approve",
  提现历史记录: "Withdrawal history",
  类型: "Type",
  信息: "Information",
  付款方式: "Payment method",
  请选择付款方式: "Please choose a payment method",
  Bill_Type_RECHARGE_BACK: "Backend recharge",
  Bill_Type_RECHARGE_ONLINE: "Online recharge",
  Bill_Type_RECHARGE_REGISTER: "Register for free",
  Bill_Type_RECHARGE_JACKPOT: "Recharge bonus",
  Bill_Type_RECHARGE_PRESENT: "Recharge rewards",
  Bill_Type_RECHARGE_FROM_COMMISSION: "Commission transfer",
  Bill_Type_RECHARGE_TG_COMMISSION: "Recharge promotion commission",
  Bill_Type_REGISTER_TG_COMMISSION: "Registration promotion commission",
  Bill_Type_WITHDRAW: "Withdraw",
  Bill_Type_WITHDRAW_REJECT: "Withdrawal rejected",
  Bill_Type_DEDUCT_HANDLE: "Manual deduction",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "Recharge correction",
  Bill_Type_MINING_PROFIT: "Mining income",
  Bill_Type_MINING_PROFIT_COMMISSION: "Mining income promotion commission",
  Bill_Type_VIP_UPGRADE: "Upgrade VIP",
  Bill_Type_FINANCE_BUY: "Purchase financial products",
  Bill_Type_FINANCE_CAPITAL_RETURN: "Return of financial balance",
  Bill_Type_FINANCE_FEE: "Financial management fees",
  Bill_Type_FINANCE_PROFIT: "Financial management income",
  Bill_Type_FINANCE_BUY_COMMISSION:
    "Commission for purchasing financial products",
  Bill_Type_FINANCE_PROFIT_COMMISSION: "Financial product income commission",
  Bill_Type_WHEEL_DRAW: "Big wheel lottery",
  Bill_Type_BUY: "Buy goods",
  Bill_Type_PAY_SHOP: "Pay for shipping",
  Bill_Type_BUY_COMMISSION: "Commission on purchased items",
  Bill_Type_DEPOSIT: "Pay deposit",
  Bill_Type_STORE_BUY: "Buy goods",
  Bill_Type_STORE_BUY_REFUND: "Purchase product refund",
  Bill_Type: "Account change type",
  Before_Money: "Previous amount",
  Deal_Money: "Account change amount",
  After_Money: "Amount after",
  Bill_Time: "Account change time",
  No_More_Data: "No more data",
  Apply_Money: "Application Amount",
  Apply_Time: "Application time",
  Withdraw_Info: "Handling fee: {fee}, arrival: {money}",
  提款订单状态_CHECKING: "Pending review",
  提款订单状态_TRANSFERRING: "Transferring",
  提款订单状态_PASS: "Confirmed",
  提款订单状态_REJECT: "Dismissed",
  暂无可用充值方式: "No recharge method available yet",
  钱包收款码: "Wallet payment code",
  钱包地址: "Wallet address",
  金额限制: "Amount limit",
  复制: "Copy",
  付款凭证: "Payment voucher",
  收款银行: "Beneficiary Bank",
  收款人: "Payee",
  收款账号: "Payment account number",
  付款银行: "Payment bank",
  付款人: "Payer",
  付款账号: "Payment account",
  请输入付款银行: "Please enter payment bank",
  请输入付款人: "Please enter the payer",
  请输入付款账号: "Please enter payment account number",
  请上传付款凭证: "Please upload payment voucher",
  充值金额: "Recharge amount",
  请输入充值金额: "Please enter the recharge amount",
  submitting: "Submitting...",
  Confirm: "Submit",
  Commit_Success: "Submitted successfully",
  balanceType_BALANCE: "Balance",
  balanceType_COMMISSION: "Commission",
  Balance: "Account Balance",
  Wash_Money: "Add mosaic",
  请选择银行账户: "Please select a bank account",
  卡号类型: "Card type",
  提现金额: "Withdrawal Amount",
  提款金额: "Withdrawal amount",
  不能为空: "Can not be empty",
  金额不正确: "The amount is incorrect",
  please_input_withdraw_password: "Please enter the withdrawal password",
  withdraw_password_format_error: "Withdrawal password must be 4-16 characters",
  Fee: "Handling fee",
  实际到账: "Actual arrival",
  交易币种: "Transaction currency",
  原始密码: "Original password",
  confirm_password_error: "The password entered twice is incorrect",
  save_success: "Saved successfully",
  please_input: "Please enter",
  old_password: "Old Password",
  new_password: "New Password",
  please_input_confirm_password: "Please confirm password again",
  没有找到符合条件的商品: "No matching products found",
  Search: "Search",
  全部: "All",
  EnumGoodsOrderState_USER_PAY: "Awaiting delivery",
  EnumGoodsOrderState_SHOP_PAY: "Delivering",
  EnumGoodsOrderState_SUCCESS: "Finish",
  EnumGoodsOrderState_CANCEL: "Cancelled",
  EnumGoodsOrderState_REFUND_SUCCESS: "Refunded",
  订单号: "Order number",
  用户名称: "User name",
  收益: "Income",
  支付时间: "Payment time",
  配送时间: "Delivery Time",
  完成时间: "Complete time",
  发货: "Ship",
  全选: "Select all",
  物品已添加到愿望清单: "Item added to wish list",
  物品已添加到比较列表: "Item added to comparison list",
  购买成功提示: "Congratulations, your purchase is successful",
  订单列表: "Order List",
  商品名: "Product name",
  图片: "Picture",
  没有品牌: "No brand",
  基本信息: "Basic Information",
  Account_Name: "Account opening name",
  Bank_Account: "Bank Account",
  Bank_Phone: "Reserve mobile phone number",
  IFSC: "IFSC account",
  UPI: "UPI",
  PIX: "PIX",
  CPF: "CPF",
  GCASH: "GCASH account",
  POWWI: "POWWI account",
  身份证号: "ID number",
  Edit: "Revise",
  Delete: "Delete",
  Add: "New",
  Forget_Withdraw_Password: "Forgot withdrawal password",
  Bank_Card_Info: "Bank card information",
  收款人地址: "Payee Address",
  SWIFT: "SWIFT",
  Bank_Branch: "Branch name",
  分行代码: "Branch code",
  银行地址: "Bank address",
  Email: "Email",
  银行卡长度必须超过: "The length of the bank card must exceed {length}",
  银行卡格式不正确: "Bank card format is incorrect",
  Do_you_confirm_delete: "Confirm deletion?",
  Please_Login_First: "Please log in first",
  Bank_Name: "Bank name",
  Please_add_bank_first:
    "You have not bound your bank card yet, please add it first",
  withdrawType: "Withdrawal type",
  withdraw_money_limit:
    "Withdrawal amount must be greater than 0 and less than or equal to {balance}",
  withdraw_times_limit:
    "You have withdrawn {todayWithdrawNum} times today, and a handling fee of {withdrawFee}% will be charged after {limitTimes} times. Are you sure to withdraw?",
  Copy_Success: "Copied successfully",
  商店首页: "Store home page",
  所有产品: "All products",
  新到货产品: "Newly arrived products",
  所有商家: "All merchants",
  请上传: "Please upload",
  请输入: "Please enter ",
  忘记密码: "Forget the password",
  记得我: "Remember me",
  共_件: "Total {0} items",
  取消订单: "Cancel order",
  申请退款: "Request a refund",
  未知商家: "Unknown merchant",
  到账: "Receipt",
  提款订单状态: "Withdrawal order status",
  前_名类别: "Top {0} categories",
  取消订单原因_不想要了: "Don't want it anymore",
  取消订单原因_商品错选_多选: "Wrong product selection/multiple selections",
  取消订单原因_商品无货: "Product out of stock",
  取消订单原因_地址信息填写错误: "Address information filled in incorrectly",
  取消订单原因_商品降价: "Product price reduction",
  取消订单原因_价格高于其他平台: "The price is higher than other platforms",
  取消订单原因_没用_少用_错用优惠: "No use/less use/misuse of discounts",
  退款原因_拍错_多拍_不喜欢: "Wrong shot / extra shot / don’t like it",
  退款原因_商品成分描述不符: "Product ingredient description does not match",
  退款原因_与商家协商一致退款: "Refund as agreed with merchant",
  退款原因_生产日期_保质期与商品描述不符:
    "The production date/shelf life does not match the product description",
  退款原因_图片_产地_批号_规格等描述不符:
    "Pictures/origin of origin/batch number/specifications and other descriptions do not match",
  退款原因_质量问题: "Quality issues",
  退款原因_商品变质_发霉_有异物:
    "The product is spoiled/mouldy/has foreign matter",
  退款原因_少件_含缺少配件_: "Few pieces (including missing accessories)",
  退款原因_收到商品时有破损_污渍_变形:
    "The item was damaged/stained/deformed when received.",
  退款原因_假冒品牌: "Counterfeit brands",
  退款原因_发票问题: "Invoice issues",
  退款原因_商家发错货: "The merchant sent the wrong goods",
  退款原因_预约不到_商家不给退换:
    "Can't make an appointment/the merchant won't give you a refund or exchange",
  退款失败: "Refund failed",
  退款处理中: "Refund in progress",
  默认: "Default",
  产品查询: "Product Search",
  商店LOGO: "Store LOGO",
  推广码: "Promotion code",
  查看所有: "View all",
  确认收货成功: "Confirm receipt of goods successfully",
  物流公司: "Logistics company",
  物流单号: "Shipment number",
  发货时间: "Shipping time",
  请先选择商品规格: "Please select product specifications first",
  个人信息: "Personal information",
  您的用户名: "Your username",
  你的名字: "Your name",
  登录名: "Username",
  你的邮件: "Your email",
  你的密码: "Your password",
  重复输入密码: "Repeat password",
  店铺名称: "Store Name",
  证书类型: "Certificate type",
  身份证: "ID card",
  护照: "Passport",
  驾驶执照: "Driver's license",
  社会保障卡: "Social security card",
  证书正面: "Certificate front",
  证书反面: "Certificate reverse side",
  确认收货: "Confirm receipt",
  请选择取消订单的原因必选:
    "Please select the reason for canceling the order (required):",
  请选择申请退款的原因必选:
    "Please select the reason for requesting a refund (required):",
  留言: "Message",
  请输入留言: "Please enter a message",
  没有帐户: "No account",
  钱包充值: "Wallet recharge",
  输入您的文字: "Enter your text",
  商家登录: "Merchant login",
  有关此产品的任何查询: "Any inquiries about this product",
  产品名称: "Product name",
  你的问题: "Your problem",
  白银店铺: "Silver shop",
  铂金店铺: "Platinum store",
  钻石店铺: "Diamond shop",
  照片: "Photo",
  已退货: "Returned",
  邮寄状态: "Mailing status",
  订单摘要: "Order summary",
  收件地址: "Recipient address",
  订购日期: "Order date",
  订单状态: "Order Status",
  总订单金额: "Total order amount",
  邮寄方式: "Mailing method",
  附加信息: "Additional Information",
  订单详细信息: "Order details",
  交货类型: "Delivery type",
  进行评论: "Make a comment",
  已评论: "Commented",
  订单金额: "Order amount",
  优惠券: "Coupon",
  统一运费: "Flat shipping fee",
  送货地址: "Shipping Address",
  评分: "Score",
  你的意见: "Your opinion",
  匿名: "Anonymous",
  现金: "Cash",
  详情: "Details",
  收货地址: "Shipping address",
  暂时没有对话: "No conversation yet",
  你: "You",
  输入您的回复: "Enter your reply",
  删除成功: "Successfully deleted",
  品牌: "Brand",
  已缴纳的保证金: "Security deposit paid",
  黄金店铺: "Gold store",
  没有更多数据: "No more data",
  站内信: "Site message",
  系统通知: "System notification",
  邮箱: "Mail",
  手机号: "Phone number",
  你的手机号: "Your phone number",
  营业执照: "Business license",
  你的邮箱: "Your mailbox",
  搜索结果: "Search result",
  系统公告: "System notification",
  客服: "Customer service",
  消息已撤回: "Message has been withdrawn",
  物流详情: "Logistics details",
  充值: "Recharge",
  提现: "Withdraw",
  信用分: "Credit score",
  余额: "Balance",
  佣金: "Commission",
  继续购物: "Continue shopping",
  订单结算: "Order settlement",
  加入对比: "Add to comparison",
  佣金余额: "Commission balance",
  佣金转余额: "Commission to balance",
  转入金额: "Transfer amount",
  不填则全部转入: "Leave blank to transfer all",
  全部转入: "Transfer all",
  转入成功: "Transfer successful",
  转入金额格式错误: "Invalid transfer amount",
  刷新: "Refresh",
  刷新成功: "Refresh successful",
  官网: "Official website",
  税号: "Tax ID",
  订单: "Orders",
  合计: "Total",
  系统安全: "System security",
  Recharge_Money_Limit: "The top-up amount must be between {min} and {max}",
  限时优惠: "Limited Time Offer",
  高价回收: "High price recycling",
  姓名: "Name",
  商品订单号: "Product order number",
  商品在线回收: "Product online recycling",
  提交: "Submit",
  回收记录: "Recycling record",
  回收状态: "Recycling status",
  回收价格: "Recycling price",
  纳税码: "Tax code",
  买家登录: "Login",
  买家注册: "Register",
  language: "英语",
  助力提示:
    "Helping merchants can increase the platform's exposure to their stores, and the higher the cumulative number of days, the higher the exposure.",
  已累计助力: "Cumulatively assisted",
  今日已助力: "Today has helped",
  立即助力: "Help immediately",
  商家助力: "Merchant help",
  证件号码: "ID number",
  证书号码: "Certificate number",
  男鞋: "Men's shoes",
  游戏玩具: "Game toys",
  使用条款: "terms of use",
  商家: "Merchant",
  已助力: "Has helped",
  被助力: "Being helped",
  用户: "user",
  助力记录: "Help record",
  消息类型: "Message Type",
  消息内容: "Message content",
  链接: "Link",
  文本: "text",
  清空: "Clear",
  评论成功: "Comment successful",
  扫描二维码: "Scan the QR code",
  转入: "transfer in",
  收款: "Collection",
  任务下单中心: "Task order center",
  记录: "record",
  任务倒计时: "Task countdown",
  倒计时后自动放弃: "Automatically give up after countdown",
  业务码: "Business code",
  选择商品分类: "Select product category",
  可多选: "Multiple selections possible",
  加载分类中: "Loading categories",
  暂无分类: "No classification yet",
  产品类别: "Product Category",
  账户余额: "Account balance",
  立即结算: "Settlement immediately",
  任务已自动放弃: "The task has been automatically abandoned",
  商品分类: "Product classification",
  订单详情: "Order details",
  预计收益: "Estimated revenue",
  预计佣金收益: "Estimated commission income",
  收益率: "Yield",
  扣款账户: "Debit account",
  确认结算: "Confirm settlement",
  未选择: "Not selected",
  请选择商品分类: "Please select a product category",
  下单成功: "Order placed successfully",
  下单失败: "Order failed",
  请重试: "Please try again",
  订单记录: "Order record",
  没有更多了: "no more",
  业务号: "Business number",
  商品类型: "Product type",
  佣金收益: "commission income",
  待结算: "Pending settlement",
  已结算: "Settled",
  已取消: "Canceled",
  加载失败: "Loading failed",
  倒计时: "Countdown",
  随机商品: "random items",
  为: "for",
  商户助力可提升商品曝光度: "Merchant assistance can increase product exposure",
  累计助力越高推荐权重越高:
    "The higher the accumulated assistance, the higher the recommendation weight.",
  实时助力动态: "Real-time assistance dynamics",
  助力奖励: "Boost rewards",
  随机奖励金额已生成: "Random reward amount has been generated",
  开心收下: "Happy to accept it",
  助力已结束: "Help has ended",
  助力成功: "Help success",
  成功: "success",
  进行中: "In progress",
  等待: "wait",
   助力失败: "Help failed",
   任务: "Task",
   下单失败_请稍后重试: "Order failed, please try again later",
   language: "英语",
};
